import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EContentSources } from '@common/enums';

import { PagesFacade } from '@web/store/website/pages/pages.facade';

import { BaseDrawerComponent } from '../base-drawer.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { PagesDrawerListComponent } from './pages-drawer-list/pages-drawer-list.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-page-drawer',
    templateUrl: './page-drawer.component.html',
    styleUrls: ['./page-drawer.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('slideIn', [
            transition(':enter', [
                style({ transform: 'translate3d(-100%, 0, 0)' }),
                animate('200ms', style({ transform: 'translate3d(0, 0, 0)' })),
            ]),
            transition(':leave', [
                style({ transform: 'translate3d(0, 0, 0)' }),
                animate('200ms', style({ transform: 'translate3d(-100%, 0, 0)' })),
            ]),
        ]),
    ],
    imports: [NgIf, PagesDrawerListComponent, AsyncPipe, TranslateModule],
})
export class PageDrawerComponent extends BaseDrawerComponent {
    private readonly pagesFacade: PagesFacade = inject(PagesFacade);

    public readonly showDrawer$: Observable<boolean> = this.layoutFacade.showPageDrawer$;
    public readonly isButtonDisabled$: Observable<boolean> = this.pagesFacade.currentPage$.pipe(
        map((page) => page?.content_source_id === EContentSources.WebChatBot)
    );

    public addNewPage(): void {
        this.pagesFacade.addNewPage();
    }
}
